// components/SecurityTable.jsx
import {
    Box,
    Chip,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import React from 'react';

const SecurityTable = ({ securityOfficerList, loading }) => {
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        borderRadius: 3, 
        overflow: 'hidden',
        height: '100%'
      }}
    >
      <Box 
        sx={{ 
          p: 2, 
          background: 'black', 
          color: 'white',
          borderBottom: '1px solid rgba(224, 224, 224, 0.4)'
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Current Security
        </Typography>
      </Box>
      
      <TableContainer sx={{ maxHeight: 350 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Guard ID
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Name
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Phone
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                    <CircularProgress size={30} sx={{ color: '#129bab' }} />
                  </Box>
                </TableCell>
              </TableRow>
            ) : securityOfficerList && securityOfficerList.length > 0 ? (
              securityOfficerList.map((officer) => (
                <TableRow 
                  key={officer.id}
                  hover
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>{officer.security_serial_no}</TableCell>
                  <TableCell>{officer.security_gaurd_name}</TableCell>
                  <TableCell>{officer.phone_number}</TableCell>
                  <TableCell>
                    <Chip
                      label={officer.status === 1 ? 'Active' : 'Inactive'}
                      color={officer.status === 1 ? 'success' : 'warning'}
                      size="small"
                      sx={{ 
                        fontWeight: 600,
                        backgroundColor: officer.status === 1 ? '#4caf50' : '#ff9800',
                        color: 'white'
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography variant="body1" py={2}>
                    No security officers registered
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SecurityTable;